const POSTFIXES_ENG = ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'];

class NumberPostfix {
  constructor() {
    return (input, locale) => {
      if (isNaN(input)) return;

      const no = input * 1;
      switch (locale) {
        case 'en_US':
          return this.getEnglish(no);
        case 'es_US':
          return this.getSpanish(no);
        default:
          return '';
      }
    };
  }

  getEnglish(no) {
    if (no === 0) return '';
    return no % 100 >= 11 && no % 100 <= 13 ? 'th' : POSTFIXES_ENG[no % 10];
  }

  getSpanish() {
    // TODO: implement when business requirements are defined
  }
}

export default NumberPostfix;



// WEBPACK FOOTER //
// ./src/modules/utils/lsp-filters/number-postfix-filter.js